import { Spinner } from "@blueprintjs/core";
import { Classes } from "@blueprintjs/core";
import * as React from "react";
import styled from "~/styled";

const SpinnerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: grid;
  align-content: center;
  justify-content: center;
  background-color: #000a;
  color: #fff;
`;

export default class Loader extends React.Component {
  public render() {
    return (
      <SpinnerContainer className={Classes.DARK}>
        <Spinner intent="primary" />
      </SpinnerContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loader.tsx